import axios from 'axios';
import { API_URL, API_BASE_ORIGIN, resolveImageUrl } from '../../api';

export { API_BASE_ORIGIN };

const adminApi = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      if (window.location.pathname.startsWith('/admin') && !window.location.pathname.includes('/login')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

// resolve a stored image path (/uploads/...) to a full URL
export const imageUrl = resolveImageUrl;

// ---- Auth ----
export const loginAdmin = async (email, password) => {
  const { data } = await adminApi.post('/auth/login', { email, password });
  return data;
};

// ---- Portfolio ----
export const getPortfolio = async (params = {}) => {
  const { data } = await adminApi.get('/portfolio', { params });
  return data;
};

export const createPortfolio = async (formData) => {
  const { data } = await adminApi.post('/portfolio', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const updatePortfolio = async (id, formData) => {
  const { data } = await adminApi.put(`/portfolio/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const updatePortfolioFields = async (id, fields) => {
  const { data } = await adminApi.put(`/portfolio/${id}`, fields);
  return data;
};

export const updatePortfolioStatus = async (id, status) => {
  const { data } = await adminApi.put(`/portfolio/${id}/status`, { status });
  return data;
};

export const deletePortfolio = async (id) => {
  const { data } = await adminApi.delete(`/portfolio/${id}`);
  return data;
};

export default adminApi;
